export default function SendToSubjects({formik}) {
    return (
        <div className="row py-4">
            <div className="col-md-8 offset-md-2 mt-4">
                <h3 className="heading fs_20">Send to Subjects/Raters</h3>
                <p className="fw-semibold fs_16 mt-4">Are you sure you want to send this assessment to the subjects/raters?</p>
                <button className="btn send_btn text-white">Click here to Send</button>
                {/* <div className="py-3">
                    <div className="d-flex align-items-center">
                        <p className="fw-semibold fs_16 mb-0">Conformation Status: </p>
                        <div class="fw-semibold d-flex align-items-center ms-3">
                            <span class="px-2 py-1 border border-success border-1 text-success rounded">Approved</span>
                        </div>
                        <div class="fw-semibold d-flex align-items-center ms-3">
                            <span class="px-2 py-1 border border-warning border-1 text-warning rounded">Pending</span>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    )
}